module.exports = __webpack_public_path__ + "assets/img/88_525_1.4b33c5c0.jpg";